import { identity } from 'transformation-matrix'
import { TransformMatrix } from '../types'

export type TransformMatrixState = TransformMatrix

export const initialTransformMatrixState: TransformMatrixState = identity()
